import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {
        padding: 40,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    button: {
        marginTop: 16
    }
});
